/**
 * A versão PRÓPRIA do Mirezi — card 1886633947408893581 (o catálogo de versões).
 *
 * As três telas "Sobre" (desktop, celular e o painel /admin) mostravam o número do Affine
 * (`BUILD_CONFIG.appVersion`), que é o do fornecedor. Decisão do operador: onde aparece a
 * versão do fornecedor, aparece a nossa com a base ao lado — "Mirezi 6.0.23.3 · base Affine
 * v2026.8.17-canary.914".
 *
 * ⚠️ O número NÃO vem do build. O build do Affine não roda a cada versão da plataforma (ele só
 * roda quando o fonte dele muda — Regra 8.7.3), então um número assado no bundle ficaria parado
 * no dia do último build. Ele vem da barra da plataforma, que toda página do Mirezi já carrega
 * (`/__barra/barra.js`, patch 0010): o gatekeeper antepõe `window.__TUNINHO_BARRA__`, e desde
 * este card ela traz `versoes` — lido de `core/versoes.json` a cada montagem.
 *
 * Sem barra (ambiente sem gatekeeper, rota fora do ar) ou sem o catálogo, devolve `null` e a
 * tela mostra `BUILD_CONFIG.appVersion` como sempre.
 *
 * Função pura e sem import: `cli/tests/js/versao-propria-do-mirezi.test.ts` a EXECUTA.
 */

type Entrada = {
  id?: unknown;
  nome?: unknown;
  versao?: unknown;
  base?: { nome?: unknown; versao?: unknown } | null;
};

const ID_DO_MIREZI = 'mirezi';

const texto = (v: unknown): v is string => typeof v === 'string' && v.trim() !== '';

/** "{nome} {versao} · base {base.nome} {base.versao}" da ferramenta `id`, ou `null`. */
export function rotuloDaVersaoPropria(
  barra: unknown,
  id: string = ID_DO_MIREZI
): string | null {
  if (!barra || typeof barra !== 'object') return null;
  const versoes = (barra as { versoes?: unknown }).versoes;
  if (!Array.isArray(versoes)) return null;
  const f = (versoes as Entrada[]).find(x => !!x && x.id === id);
  if (!f || !texto(f.nome) || !texto(f.versao)) return null;
  const base = f.base;
  return base && texto(base.nome) && texto(base.versao)
    ? `${f.nome} ${f.versao} · base ${base.nome} ${base.versao}`
    : `${f.nome} ${f.versao}`;
}

/** O rótulo lido da barra desta página — `null` quando ela não está (ou não trouxe o número). */
export function versaoPropriaDaPagina(): string | null {
  return rotuloDaVersaoPropria(
    (globalThis as { __TUNINHO_BARRA__?: unknown }).__TUNINHO_BARRA__
  );
}
